module.exports = __webpack_public_path__ + "static/img/img1.c94d10c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/double11/1/img1.png
// module id = qUda
// module chunks = 1